var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 18 18"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\n    icons8-instagram\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "none",
    d: "M5 0a5 5 0 00-5 5v8a5 5 0 005 5h8a5 5 0 005-5V5a5 5 0 00-5-5H5zm10 2a1 1 0 110 2 1 1 0 010-2zM9 4a5 5 0 11-.001 10.001A5 5 0 019 4zm0 2a3 3 0 100 6 3 3 0 000-6z",
    fillRule: "nonzero",
    strokeWidth: 1
  }))));
};
export default SvgInstagram;